import { GraduationCap, Wrench, Sparkles, MapPin } from "lucide-react";

const milestones = [
  {
    icon: GraduationCap,
    date: "The beginning",
    title: "Kicked out, kit in hand",
    text: "LAC started from a boy who got kicked out of secondary school. No workshop, no funding — just a starter kit, an A-Class, and a stubborn refusal to give up.",
  },
  {
    icon: Wrench,
    date: "Year one",
    title: "Self-taught, car by car",
    text: "Every install was a lesson. Every TikTok was a portfolio entry. Friends became customers, customers became referrals, and the quality kept climbing.",
  },
  {
    icon: Sparkles,
    date: "Today",
    title: "OEM-grade craft",
    text: "From single fibre strips to full constellation roofs and Mercedes screen-integrated ambient — the standard keeps rising. Every car better than the last.",
  },
  {
    icon: MapPin,
    date: "What's next",
    title: "A new chapter",
    text: "Same hands, more space. A second LAC workshop is on the way — same obsession, more cars, no shortcuts.",
  },
];

export default function OurStory() {
  return (
    <section className="py-32" data-testid="our-story-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5">
          <div className="text-xs tracking-[0.35em] text-[#FF2D87] mb-4">/ OUR STORY</div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter">
            From <span className="neon-violet">expelled</span><br />
            to <span className="neon-cyan">East London's go-to</span>.
          </h2>
          <p className="mt-6 text-zinc-400 font-body leading-relaxed">
            LAC didn't start in a glossy showroom. It started with a boy who'd just been kicked out of
            secondary school — nothing in his name but a starter kit and an A-Class on the driveway.
            One car turned into ten. Ten turned into a hundred. Every install taught him something new,
            and every TikTok kept him honest.
          </p>
          <p className="mt-4 text-zinc-400 font-body leading-relaxed">
            Years on, the quality has only grown — OEM-grade fitments, Mercedes screen-integrated
            ambient, hand-laid fibre roofs — built in East London, never compromising on finish.
          </p>

          <div className="grid grid-cols-3 gap-5 mt-10 pt-8 border-t border-white/10">
            <div>
              <div className="font-display font-bold text-3xl text-white">1000+</div>
              <div className="text-xs tracking-[0.2em] text-zinc-500 mt-1">VEHICLES</div>
            </div>
            <div>
              <div className="font-display font-bold text-3xl text-white">5★</div>
              <div className="text-xs tracking-[0.2em] text-zinc-500 mt-1">GOOGLE</div>
            </div>
            <div>
              <div className="font-display font-bold text-3xl text-white">9K+</div>
              <div className="text-xs tracking-[0.2em] text-zinc-500 mt-1">TIKTOK</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 space-y-4">
          {milestones.map((m, i) => {
            const Icon = m.icon;
            return (
              <div
                key={i}
                data-testid={`milestone-${i}`}
                className="p-6 rounded-sm border border-white/10 bg-[#0c0c0c] flex gap-5 hover:border-[#D946EF]/40 transition group"
              >
                <div className="w-12 h-12 rounded-sm bg-[#D946EF]/10 border border-[#D946EF]/30 flex items-center justify-center shrink-0 group-hover:scale-110 transition">
                  <Icon className="w-5 h-5 text-[#D946EF]" />
                </div>
                <div>
                  <div className="text-[11px] tracking-[0.25em] text-[#D946EF] mb-1">{m.date}</div>
                  <h3 className="font-display font-semibold text-xl mb-1.5">{m.title}</h3>
                  <p className="text-zinc-400 text-sm font-body leading-relaxed">{m.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
